module.exports = __webpack_public_path__ + "media/site/images/products/actionplan-flat-screen4@2x-e22654f90365abf462f31a320d29eb11.png";